<template>
    <v-container id="contactus">
        <v-row class="text-center text-md-left">
            <v-col cols="12" md="4" data-aos="fade-up">
                <h3 class="mb-2 d-flex align-center justify-center justify-md-start primary--text font-weight-bold subtitle-1">
                    <v-icon class="mr-2" color="primary">mdi-home-city-outline</v-icon>
                    Contact Us
                </h3>
                <div class="d-flex align-center justify-center justify-md-start mb-1">
                    <span>sdlee@code-line.kr</span>
                    <v-tooltip top>
                        <template v-slot:activator="{ on }">
                            <v-btn icon x-small class="ml-1 copy-btn" v-on="on" @click="copyEmail">
                                <v-icon x-small>{{ copied ? 'mdi-check' : 'mdi-content-copy' }}</v-icon>
                            </v-btn>
                        </template>
                        <span>{{ copied ? '복사됨!' : '이메일 복사' }}</span>
                    </v-tooltip>
                </div>
                <address class="mt-3">
                    대전광역시 유성구 복용동로 43<br />더리브시그니처 F741호
                </address>
            </v-col>
            <v-spacer></v-spacer>
        </v-row>
        <footer class="grey--text overline text-center text-md-left mt-10 d-flex justify-center justify-md-space-between align-md-center">
            <div>CODELINE Corp. © 2021</div>
            <img src="@/assets/small_logo.svg" alt="codeline" @click="$vuetify.goTo(0)" />
        </footer>
    </v-container>
</template>

<style scoped lang="scss">
address {
    font-size: 0.9rem;
    font-style: normal;
}
footer img {
    width: 50px;

    @media #{map-get($display-breakpoints, 'sm-and-down')} {
        width: 20px;
        margin-left: 8px;
    }
}
.copy-btn {
    opacity: 0.4;
    transition: opacity 0.2s;
    &:hover { opacity: 1; }
}
</style>

<script>
export default {
    name: 'Contactus',
    data: () => ({
        copied: false,
    }),
    methods: {
        copyEmail() {
            navigator.clipboard.writeText('sdlee@code-line.kr').then(() => {
                this.copied = true;
                setTimeout(() => { this.copied = false; }, 2000);
            });
        },
    },
};
</script>